import {
  Button,
  Card,
  Grid,
  List,
  ListItem,
  TextField,
  Box,
  IconButton,
  Chip,
  Switch,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Slide,
  Typography,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {
  collection,
  doc,
  deleteDoc,
  getDocs,
  addDoc,
  updateDoc,
} from "firebase/firestore/lite";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { db } from "../../Firebase";
import { Stack } from "@mui/system";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const getNumber = (number) => {
  return Number.isNaN(Number.parseFloat(number))
    ? 0
    : Number.parseFloat(number);
};

const ShopItem = () => {
  const param = useParams();
  const [newItem, setNewItem] = useState({
    name: "",
    active: true,
  });
  const [editItem, setEditItem] = useState({});
  const [dialog, setDialog] = useState(false);
  const [items, setItems] = useState([]);
  const fetchItems = async (groupId) => {
    const itemCollection = collection(db, `shop_groups/${groupId}/items`);
    const itemSnapshot = await getDocs(itemCollection);
    const itemList = itemSnapshot.docs.map((doc) => {
      const data = doc.data();
      data.id = doc.id;
      data.groupId = groupId;
      return data;
    });
    console.log("items", itemList);
    setItems(itemList.sort((x,y) => (x.active === y.active) ? 0 : x.active ? 1 : -1))
    return itemList;
  };
  const deleteItem = async (groupId, itemId) => {
    const docRef = doc(db, `shop_groups/${groupId}/items/${itemId}`);
    deleteDoc(docRef).then((result) => {
      console.log("delete doc", result);
      fetchItems(groupId);
    });
  };
  const addItem = async (groupId, item) => {
    const itemCollection = collection(db, `shop_groups/${groupId}/items`);
    addDoc(itemCollection, item).then((result) => {
      console.log("item added", result);
      fetchItems(param.id);
    });
  };
  const updateItem = async (item) => {
    console.log("item update", item);
    const itemRef = doc(db, `shop_groups/${param.id}/items/${item.id}`);
    updateDoc(itemRef, item).then((result) => {
      console.log("item updated", result);
      fetchItems(param.id);
    });
  };
  useEffect(() => {
    fetchItems(param.id);
  }, [param.id]);
  return (
    <div>
      <Grid container justifyContent={"center"}>
        <Box container minWidth={"400px"}>
          <Stack direction={"row"} justifyContent={"center"}>
            <h1>Shop Items</h1>
          </Stack>
          <Box
            width="100%"
            display="flex"
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Stack width={"100%"} spacing={2} padding={2}>
              <TextField
                id="outlined-basic"
                label="New Item"
                variant="outlined"
                type="text"
                value={newItem.name}
                onChange={(event) =>
                  setNewItem({
                    ...newItem,
                    name: event.target.value,
                  })
                }
              />
              <Button
                variant="contained"
                onClick={() => {
                  addItem(param.id, newItem);
                }}
              >
                Add Item
              </Button>
            </Stack>
          </Box>

          <Stack
            direction="row"
            spacing={2}
            padding={2}
            justifyContent="center"
          >
            <Chip
              label={
                "Total Active: " + items.filter((it) => it.active).length
              }
              variant="outlined"
            />
            <Chip
              label={
                "Total Price: $" +
                items
                  .filter((it) => it.active)
                  .reduce((sum, item) => sum + getNumber(item.price), 0)
                  .toFixed(2)
              }
              variant="outlined"
            />
          </Stack>
          <List>
            {Array.isArray(items) &&
              items
                .sort((x, y) => (x === y ? 0 : x ? -1 : 1))
                ?.map((item) => (
                  <Card key={item.id} variant="outlined">
                    <ListItem key={item.id}>
                      <Box
                        key={item.id}
                        width="100%"
                        display="flex"
                        alignItems={"center"}
                        justifyContent={"space-between"}
                      >
                        <Box width={"70%"}>
                          <Stack>
                            <Typography variant="h6" component="h2">
                              {item.name}
                            </Typography>
                            <Typography variant="caption" component="h2">
                              {item.notes}
                            </Typography>
                          </Stack>
                        </Box>
                        <Box
                          width="30%"
                          display="flex"
                          alignItems={"center"}
                          justifyContent={"space-between"}
                        >
                          <Switch
                            checked={item.active}
                            color={item.active ? "primary" : "default"}
                            onChange={(event) => {
                              item.active = event.target.checked;
                              updateItem(item);
                            }}
                          />
                          <IconButton
                            aria-label="edit"
                            color="primary"
                            onClick={() => {
                              setEditItem({
                                ...item,
                                notes:
                                  item.notes === undefined ? "" : item.notes,
                                price:
                                  item.price === undefined ? 0.0 : item.price,
                              });
                              setDialog(true);
                            }}
                          >
                            <EditIcon />
                          </IconButton>
                        </Box>
                      </Box>
                    </ListItem>
                  </Card>
                ))}
          </List>
        </Box>
        <Dialog
          fullWidth
          open={dialog}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => setDialog(false)}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle>Edit "{editItem.name}"</DialogTitle>
          <DialogContent>
            <Stack spacing={2} p={5}>
              <TextField
                id="outlined-basic"
                label="Name"
                variant="outlined"
                type="text"
                InputLabelProps={{ shrink: true }}
                value={editItem.name}
                onChange={(event) => {
                  setEditItem({
                    ...editItem,
                    name: event.target.value,
                  });
                }}
              />
              <TextField
                id="outlined-basic"
                label="Notes"
                variant="outlined"
                type="text"
                InputLabelProps={{ shrink: true }}
                value={editItem.notes}
                onChange={(event) => {
                  setEditItem({
                    ...editItem,
                    notes: event.target.value,
                  });
                }}
              />
              <TextField
                id="outlined-basic"
                label="Price"
                variant="outlined"
                type="number"
                step="0.01"
                InputLabelProps={{ shrink: true }}
                value={editItem.price}
                onChange={(event) => {
                  setEditItem({
                    ...editItem,
                    price: Number.isNaN(Number.parseFloat(event.target.value))
                      ? 0
                      : Number.parseFloat(event.target.value),
                  });
                }}
              />
            </Stack>
          </DialogContent>
          <DialogActions>
            <Stack
              direction={"row"}
              justifyContent="end"
              spacing={2}
              padding={3}
            >
              <Button
                aria-label="delete"
                color="error"
                onClick={() => {
                  deleteItem(editItem.groupId, editItem.id);
                  setDialog(false);
                }}
              >
                <DeleteIcon /> Delete
              </Button>
              <Button onClick={() => setDialog(false)}>Cancel</Button>
              <Button
                onClick={() => {
                  updateItem(editItem);
                  setDialog(false);
                }}
              >
                Update
              </Button>
            </Stack>
          </DialogActions>
        </Dialog>
      </Grid>
    </div>
  );
};

export default ShopItem;
